export const locale = {
    lang: 'en',
    data: {
        LIST_CLINIC_MESSAGE: {
            TITLE: 'Message',
            RESOLVE: 'Resolve',
            REOPEN: 'Reopen',
            EMPTY_MESSAGE: {
                TITLE: 'No message selected',
                DESCRIPTION: 'Select the order on the side',
            },
            EMPTY_ORDER_MESSAGE: 'No orders found',
            EMPTY_ORDER_SEARCH_MESSAGE: 'Search for an order',
            REMAKE_TYPE: {
                REMAKE: 'Remake',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Adjustment',
                ADJUSTMENT_INITIAL: 'A',
            },
            EMPTY_PATIENT: 'Patient not defined',
            DELETED_MESSAGE: 'Deleted message',
            COMPLETE_DATE_FORMAT: "MMMM dd, yyyy",
            TAGS: {
                OPEN: 'Open',
                NOT_READ: 'Unread',
                RESOLVED: 'Resolved',
            },
            FORM: {
                FIELDS: {
                    MESSAGE: 'Type your message',
                    SEARCH_ORDER_MESSAGE: 'Search by order number, customer or patient',
                },
            },
            MAT_MENU: {
                FILES: 'Files',
                PHOTOS_AND_VIDEOS: 'Photos and videos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'Only images or videos are allowed.',
                    FILE: 'Only files other than images or videos are allowed.',
                    MAX_FILE: 'A maximum of 15 files are allowed.',
                    MAX_FILE_SIZE: 'Files larger than 150 MB are not allowed.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Send',
                        CANCEL: 'Cancel',
                    },
                },
                PREVIEW: {
                    TITLE: 'Preview',
                },
                IMAGE: {
                    TITLE: 'View image',
                },
            },
            DIALOG: {
                GENERAL: {
                    BUTTONS: {
                        CANCEL: 'Cancel',
                        REOPEN: 'Reopen',
                    },
                },
                REOPEN: {
                    TITLE: 'Reopen conversation',
                    DESCRIPTION: 'Are you sure you want to reopen this conversation?',
                },
            },
        },
    },
};
